import { Bar } from "vue-chartjs";
import "chartjs-plugin-datalabels";

export default {
  extends: Bar,
  props: {
    color: String,
    valores: Object,
    label: String,
    suffix: { type: String, default: "" },
    smallLabel: Boolean
  },
  data: function() {
    return {
      datacollection: {
        labels: this.valores.labels,
        datasets: [
          {
            backgroundColor: this.color,
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.valores.valores
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#f0f0f0",
                fontSize: 0
              },
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#f0f0f0",
                fontSize: 12,
                fontStyle: "bold",
                callback: function(value) {
                  return value.substring(0, Math.min(value.length, 20));
                }
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            align: "center",
            anchor: "center",
            color: "#f0f0f0",
            font: {
              size: this.smallLabel ? "10" : "14",
              weight: "bold"
            },
            formatter: this.format
          }
        }
      }
    };
  },
  mounted() {
    // this.chartData is created in the mixin
    this.renderChart(this.datacollection, this.options);
  },
  methods: {
    format(value) {
      return value.toFixed(2).replace(".", ",") + this.suffix;
    }
  }
};
